// extracted by css-extract-rspack-plugin
export default {"Box":"potentially-dirty-module__Box__X5yYP","PotentiallyDirty":"potentially-dirty-module__PotentiallyDirty__mdE8Q","hasChildren":"potentially-dirty-module__hasChildren__VDaQY"};